import { GREY_900, RED_700, SIZING_3, SPACING_3, Text, remCalc } from '@mnd-frontend/ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNewsroomSetup } from '../../../../contexts/NewsroomSetupContext';
import ContactSVG from '../svg/contact.svg';
import {
  EmptyPressRelease,
  HeaderWithColoredUnderline,
  WrapperForEmptyReleases,
  boxShadow,
} from './shared';

const Content = styled.div`
  background: #f7f7f9;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  padding: ${SPACING_3};
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${SIZING_3};
    border-radius: 0px 0px 6px 6px;
    background: white;
  }
`;

const ContactCard = styled.div`
  height: ${remCalc(232)};
  width: ${remCalc(232)};
  padding: ${SPACING_3};
  color: ${GREY_900};
  background-color: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: ${SPACING_3};
  ${boxShadow};
  figure {
    width: 50%;
    height: ${remCalc(58)};
    margin: 0 0 0.4rem 0;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ContactName = styled.p`
  color: ${GREY_900};
  text-align: center;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 700;
  line-height: ${remCalc(18)};
  margin: 0;
`;

const TitleCard = styled.p`
  border: 1px solid ${RED_700};
  color: ${RED_700};
  text-transform: uppercase;
  padding: 0.3rem;
  margin: 0;
  font-size: 0.6rem;
`;

const PreviewPressContact = () => {
  const { t } = useTranslation();
  const { newsroomData } = useNewsroomSetup();
  const { primaryBrandColor } = newsroomData.branding;
  const { email, name, phone, title, imageUrl } = newsroomData['press-contact'];

  return (
    <Content>
      <WrapperForEmptyReleases $position="top">
        <EmptyPressRelease $height={15} />
        <EmptyPressRelease $height={15} />
        <EmptyPressRelease $height={15} />
      </WrapperForEmptyReleases>
      <HeaderWithColoredUnderline as="h3" $lineColor={primaryBrandColor}>
        {t('newsroom-setup_contacts')}
      </HeaderWithColoredUnderline>
      <ContactCard>
        <figure>
          <img src={imageUrl || ContactSVG} alt="avatar" />
        </figure>
        <ContactName>
          {name || t('newsroom_setup_wizard.contact_person_form.name_label')}
        </ContactName>
        <TitleCard>{t('newsroom-setup_press-contact')}</TitleCard>
        <Text as="p" variant="bodyExtraSmall">
          {title || t('newsroom_setup_wizard.contact_person_form.title_label')}
        </Text>
        <Text as="p" variant="bodyExtraSmall">
          {email || t('newsroom_setup_wizard.contact_person_form.email_label')}
        </Text>
        <Text as="p" variant="bodyExtraSmall">
          {phone || t('contacts_details_phone-placeholder')}
        </Text>
      </ContactCard>
    </Content>
  );
};

export default PreviewPressContact;
